import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  class: "d-flex justify-lg-space-between mb-4",
  style: {"width":"100%"}
}
const _hoisted_2 = {
  class: "mr-4",
  style: {"position":"relative","width":"100%"}
}
const _hoisted_3 = {
  key: 0,
  class: "d-flex"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.inputHelpIsActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_v_text_field, {
              modelValue: _ctx.latString,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.latString) = $event)),
              variant: "filled",
              style: {"width":"45%","height":"100%"},
              class: "mr-2",
              label: _ctx.t('lat'),
              suffix: "°",
              rules: [_ctx.isValidLatitude],
              error: !_ctx.insideBounds,
              "data-testid": "lat-input",
              onInput: _ctx.onChangeSingle,
              onFocus: _ctx.handleCoordinateClicked
            }, null, 8, ["modelValue", "label", "rules", "error", "onInput", "onFocus"]),
            _createVNode(_component_v_text_field, {
              modelValue: _ctx.lonString,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lonString) = $event)),
              variant: "filled",
              style: {"width":"45%","height":"100%"},
              class: "ml-2",
              label: _ctx.t('lon'),
              suffix: "°",
              rules: [_ctx.isValidLongitude],
              error: !_ctx.insideBounds,
              "data-testid": "lon-input",
              onInput: _ctx.onChangeSingle,
              onFocus: _ctx.handleCoordinateClicked
            }, null, 8, ["modelValue", "label", "rules", "error", "onInput", "onFocus"])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.inputHelpIsActive)
        ? (_openBlock(), _createBlock(_component_v_text_field, {
            key: 1,
            modelValue: _ctx.latLonString,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.latLonString) = $event)),
            style: {"width":"100%","height":"100%"},
            class: "mr-4",
            "full-width": "",
            variant: "filled",
            label: _ctx.t('lat') + ', ' + _ctx.t('lon'),
            rules: [_ctx.isValidLatLon],
            "data-testid": "lat-lon-input",
            onInput: _ctx.onChangeCombined,
            onFocus: _ctx.handleCoordinateClicked
          }, null, 8, ["modelValue", "label", "rules", "onInput", "onFocus"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_v_tooltip, {
      text: _ctx.t('raster.tooltip.reset_coordinate'),
      bottom: "",
      "open-delay": 200
    }, {
      activator: _withCtx(({ props }) => [
        _createVNode(_component_v_btn, _mergeProps(props, {
          rounded: "",
          class: "tool-button",
          elevation: 0,
          "data-testid": `remove-coordinate-for-id-${_ctx.id}`,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.timeseriesStore.removeCoordsForID(_ctx.id)))
        }), {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, null, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("mdi-delete-outline", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 16, ["data-testid"])
      ]),
      _: 1
    }, 8, ["text"])
  ]))
}